var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.971,
    height: 18,
    viewBox: "0 0 18.971 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1932",
    "data-name": "Rectangle 1932",
    width: 18.971,
    height: 18,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3478",
    "data-name": "Group 3478",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3477",
    "data-name": "Group 3477",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11143",
    "data-name": "Path 11143",
    d: "M4.621,2.21A3.159,3.159,0,0,0,1.458,5.371v7.784a3.159,3.159,0,0,0,3.163,3.162H12.4a3.159,3.159,0,0,0,3.163-3.162v-.973a.729.729,0,1,1,1.458,0v.973A4.619,4.619,0,0,1,12.4,17.778H4.621A4.619,4.619,0,0,1,0,13.155V5.371A4.619,4.619,0,0,1,4.621.749H6.567a.73.73,0,0,1,0,1.461Z",
    transform: "translate(0 0.222)",
    fill: "#152c40",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11144",
    "data-name": "Path 11144",
    d: "M12.6.051A.72.72,0,0,1,13.4.243l4.378,4.865a.73.73,0,0,1,0,.973L13.4,10.945a.73.73,0,0,1-1.273-.486V8.28a9.264,9.264,0,0,0-4.382.964,7.6,7.6,0,0,0-2.985,3.669.72.72,0,0,1-.816.4.732.732,0,0,1-.573-.715c0-3.618.948-6.1,2.711-7.646a9.428,9.428,0,0,1,6.045-2.017V.729A.726.726,0,0,1,12.6.051m.994,2.579V3.648a.727.727,0,0,1-.73.73c-2.483,0-4.459.476-5.812,1.667A6.32,6.32,0,0,0,5.133,9.557a7.046,7.046,0,0,1,1.9-1.581A11.573,11.573,0,0,1,12.861,6.81a.727.727,0,0,1,.73.73V8.558l2.665-2.964Z",
    transform: "translate(1.003 0)",
    fill: "#152c40",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.3c382f711090e7e342f3a31c7decbe07.svg";
export { ForwardRef as ReactComponent };